import React from 'react';
import styles from './FlatFilterRequestAttributes.module.scss';
import Tab from '../../../../../../components/common/Tab/Tab';
import Tabs from '../../../../../../components/common/Tabs/Tabs';
import { requestInFlatPeriodIndicators } from '../../../../../../constants/reqestForFlat';
import IndicatorBadge from '../../../../../../components/common/IndicatorBadge/IndicatorBadge';
import { requestFlatPeriod } from '../../../../../../constants/requestFlat';

const FlatFilterRequestAttributes = ({ values = [], onChange }) => {
  return (
    <Tabs
      value={values}
      onChange={onChange}
      className={styles.tabs}
    >
      {requestInFlatPeriodIndicators
        .filter(
          (indicator) => indicator?.id !== requestFlatPeriod.finishingTouches
        )
        ?.map((item, index) => (
          <Tab
            className={styles.tab}
            selectedClassName={styles.tabActive}
            key={item.id || index}
            label={
              <div className={styles.label}>
                <IndicatorBadge bgColor={item.bg} />
                <span>{item.value}</span>
              </div>
            }
            value={item.id}
          />
        ))}
    </Tabs>
  );
};

export default FlatFilterRequestAttributes;
